<!-- PAGE TITLE
        ================================================== -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1 *ngIf="header?.Title">{{ header?.Title }}</h1>
                        <p *ngIf="header?.Description">{{ header?.Description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Profiles
        ================================================== -->
<section class="bg-light-color" *ngIf="profiles.length > 0">
    <div class="container">

        <ng-container *ngFor="let p of profiles; let i = index">
            <hr *ngIf="i > 0">

            <div class="row" [class.mt-5]="i > 0">
                <div class="col-lg-3 wow fadeInUp" data-wow-delay="200ms">
                    <div class="card card-style-07 border-0 bg-transparent">
                        <div class="image ">
                            <a href="#"><img [src]="contentImg(p.Image)" [alt]="p.Name" /></a>
                        </div>
                    </div>
                </div>

                <div class="col-lg-9 ps-lg-5 mt-5 mt-lg-0 wow fadeInUp" data-wow-delay="400ms">
                    <div class="section-title left mb-3">
                        <h2 class="display-16 lh-1 mb-2">{{ p.Name }}</h2>
                        <p class="para" *ngIf="p.Designation">{{ p.Designation }}</p>
                        <div class="line"></div>
                    </div>

                    <div *ngIf="lines(p.Highlights).length > 0">
                        <ul class="list-unstyled list-style01 mb-0">
                            <li *ngFor="let l of lines(p.Highlights)">{{ l }}</li>
                        </ul>
                    </div>

                    <div class="mt-1-9" *ngIf="p.Vision">
                        <h5 class="mb-2">Vision - </h5>
                        <p class="mb-2">{{ p.Vision }}</p>
                    </div>

                    <div class="mb-3 mt-3 pb-0 wow fadeInUp" data-wow-delay="200ms">
                        <h5 class="mb-2" *ngIf="p.Headline">{{ p.Headline }}</h5>
                        <p class="mb-4" *ngFor="let t of paragraphs(p.Description)">{{ t }}</p>
                    </div>
                </div>

                <!-- optional full-width block (shown only if filled in the dashboard) -->
                <div class="col-lg-12 mt-4 wow fadeInUp" data-wow-delay="400ms" *ngIf="p.MoreHeadline || p.MoreDescription">
                    <div class="mb-0 pb-0 wow fadeInUp" data-wow-delay="200ms">
                        <h5 class="mb-2" *ngIf="p.MoreHeadline">{{ p.MoreHeadline }}</h5>
                        <p class="mb-4" *ngFor="let t of paragraphs(p.MoreDescription)">{{ t }}</p>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</section>


<!-- Vision
        ================================================== -->
<section class="bg-light-yellow2" *ngIf="vision">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 mb-3 wow fadeInUp" data-wow-delay="100ms">
                <div>
                    <div class="section-title-02 position-relative mb-3">
                        <h2 class="position-relative z-index-9 mb-0">{{ vision.Title }}</h2>
                    </div>
                    <p class="mb-2" *ngFor="let t of paragraphs(vision.Description)">{{ t }}</p>
                </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="200ms" *ngIf="vision.Image">
                <div class="text-center image-hover">
                    <img [src]="contentImg(vision.Image)" class="rounded" [alt]="vision.Title" />
                </div>
            </div>
        </div>
    </div>
</section>